import React from 'react';
import { IDeleteContactDialog } from './interfaces';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

export const DeleteContactDialog: React.FC<IDeleteContactDialog> = ({
  show,
  contactName,
  disabled = false,
  onClose,
  onConfirm,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={show}>
      <DialogTitle fontWeight="bold">
        {t('contacts:prompts.deleteContact.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans
            i18nKey="contacts:prompts.deleteContact.body"
            components={{ strong: <strong /> }}
            values={{ contactName }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={disabled}>
          {t('buttons.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={disabled}
        >
          {t('buttons.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
